<template>
  <div id="app">
    <router-view/>

    <footer class="footer">
      <hr>
      <div class="container">
        <div class="level">
          <div class="level-item">
            <a href="https://www.qatar.cmu.edu/" target="_blank">
              <img class="footer-logo footer-logo-cmuq" src="/static/cmuq.png">
            </a>
          </div>
          <div class="level-item">
            <a href="https://nyuad.nyu.edu/en/research/centers-labs-and-projects/computational-approaches-to-modeling-language-lab.html" target="_blank">
              <img class="footer-logo footer-logo-camel" src="/static/camel.png">
            </a>
          </div>
          <div class="level-item">
            <a href="https://nyuad.nyu.edu" target="_blank">
              <img class="footer-logo" src="/static/nyuad.png">
            </a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>

export default {
  name: 'app',
};

// Navbar functionality
document.addEventListener('DOMContentLoaded', () => {
  const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);
  if ($navbarBurgers.length > 0) {
    $navbarBurgers.forEach(($el) => {
      $el.addEventListener('click', () => {
        const target = $el.dataset.target;
        const $target = document.getElementById(target);
        $el.classList.toggle('is-active');
        $target.classList.toggle('is-active');
      });
    });
  }
});
</script>

<style lang="scss">

@import url('https://fonts.googleapis.com/css?family=Changa&subset=arabic');

html {
  width: 100%;
  min-height: 100vh;
}

h1,h2,h3,h4,h5,h6 {
  font-family: 'Changa', sans-serif !important;
  font-weight: 300 !important;
}

h2 {
  color: lighten(#000000, 40%) !important;
}

footer {
  padding-bottom: 3rem !important;
}

@media (min-width: 800px) {
  h1 { font-size: 3.0rem !important; }
  h2 { font-size: 1.88rem !important; }
}

.is-arabic {
  direction: rtl;
}

.is-fullwidth {
  width: 100%;
}

.is-clickable {
  cursor: pointer;
}

.navbar-item img {
  max-height: 2.3rem;
}

.modal{
  padding-top: 52px;
}

.modal-close {
  margin-top: 48px;
}

.footer-logo {
  max-height: 50px;
}

.footer-logo-camel {
  max-height: 90px;
}

.footer-logo-cmuq {
  max-width: 330px;
}

.footer-message {
  margin-bottom: 1.5rem !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue